import API from "@irati/utils/services/API"
import GenericErrorCodes from "@irati/utils/services/errorCodes/Generic"
import getCodeFromError from "@irati/utils/services/API/helpers/getCodeFromError"
import Regions from "../../enums/Regions"

export default function globalErrorHandler(err: PBError) {
  if (getCodeFromError(err) !== GenericErrorCodes.PBERRMaintenance) {
    throw err
  }

  const {config} = err.response
  const url = toggleRegion(config.url!)
  config.url = url

  return API.request(config).then((res) => res.data.data)
}

function toggleRegion(url: string) {
  if (url.indexOf(Regions.EU) > -1) {
    return url.replace(Regions.EU, Regions.US)
  }
  return url.replace(Regions.US, Regions.EU)
}
